import { render, staticRenderFns } from "./NumbersBlacklistList.vue?vue&type=template&id=34a2076e"
import script from "./NumbersBlacklistList.vue?vue&type=script&lang=js"
export * from "./NumbersBlacklistList.vue?vue&type=script&lang=js"
import style0 from "./NumbersBlacklistList.vue?vue&type=style&index=0&id=34a2076e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports